import { AsyncState, CoTypedFactory, Synchronize, Template, Unit } from 'ballerina-core'

export const AsyncLoaderTemplate = <Data,>() =>
  Template.Default<{ promise: () => Promise<Data> }, AsyncState<Data>, Unit, Unit>((props) =>
    CoTypedFactory<{}, AsyncState<Data>>().Template(asyncLoaderCoroutine(props.context.promise), {
      interval: 5,
      runFilter: (p) => p.context.kind == 'unloaded' || p.context.kind == 'loading' || p.context.kind == 'reloading',
    })(props)
  )

const asyncLoaderCoroutine = <Data,>(promise: () => Promise<Data>) =>
  Synchronize<{}, Data>(promise).embed<AsyncState<Data>, AsyncState<Data>>(
    (state) => ({ sync: state }),
    (updater) => (state) => updater({ sync: state }).sync
  )
